function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgCor = function SvgCor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.278 21.886a1.286 1.286 0 010 1.813L7.01 29.966a1.288 1.288 0 01-1.812 0l-2.731-2.732a1.285 1.285 0 010-1.811l6.267-6.269a1.284 1.284 0 011.812 0l2.732 2.732zM10.675 20.7l-.837-.838a.284.284 0 00-.397 0L3.174 26.13a.285.285 0 000 .397l2.731 2.732a.289.289 0 00.398 0l6.267-6.267a.286.286 0 000-.398l-1.895-1.895z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.119 24.91c.527.19 1.075.035 1.408-.362l3.311-3.306a1.25 1.25 0 000-1.765l-1.634-1.634a.5.5 0 10-.707.707l1.633 1.633a.25.25 0 010 .352l-3.34 3.338c-.096.112-.205.143-.303.108l-12.059-5.263a.5.5 0 00-.556.108l-1.67 1.698a.5.5 0 00.713.7l1.429-1.452 11.775 5.138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.68 2.442a1.204 1.204 0 00-1.695 0L10.937 6.49a1.204 1.204 0 000 1.696L23.372 20.62a1.202 1.202 0 001.694 0l4.049-4.048a1.2 1.2 0 000-1.695L16.68 2.442zm11.728 13.423l-4.049 4.048a.201.201 0 01-.28 0L11.643 7.479a.203.203 0 010-.283l4.047-4.047a.204.204 0 01.281 0l12.436 12.435a.2.2 0 010 .28z"
  })));
};
SvgCor.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgCor.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgCor;